// Generates a unique ID, with optional prefix.
export function useUniqueId(prefix = '') {
    const useIdCounter = () => useState('idCounter', () => 0)
    return `${prefix}${++useIdCounter.value}`
}
